<template>
    <form class="t-banner-add" @submit.stop.prevent="Submit()">
        <h2>{{ banner.title }}</h2>
        
        <!-- <label>{{ item.label }}</label> -->
            <transition-group name="fadeList" mode="out-in" tag="div" class="t-inputBox t-animation">
                <div class="t-input t-animation"
                    :class="[item.class, {_error: item.error}]"
                    v-for="(item) in formCurrent"
                    :key="item.name">
                    <label>
                        {{ item.label }}
                    </label>
                    
                    <span v-if=" item.labelSub " class="t-input__subtext">
                        {{ item.labelSub }}
                    </span>

                    <textarea-autosize v-if="item.type === 'textarea'" v-model="item.value"
                                    :min-height="80"></textarea-autosize>

                    <input v-if="item.type === 'text'" v-model="item.value">

                    <template v-if="item.type === 'file'" >
                        <transition name="fade" mode="out-in">
                            <label v-if="item.value == ''" class="t-btn t-btn_file">
                                <input type="file" accept=".jpg, .jpeg, .png" @change="LoadFile($event.target.files, item)">
                                <span>{{ item.placeholder }}</span>
                            </label>
                            <div v-else >
                                <div v-for="(itemFile, indexFile) in item.value" :key="indexFile" class="t-file t-file_full">
                                    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M23 4H10C9.44772 4 9 4.44772 9 5V35C9 35.5523 9.44772 36 10 36H30C30.5523 36 31 35.5523 31 35V12M23 4V11C23 11.5523 23.4477 12 24 12H31M23 4L31 12" stroke="#52A8F2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                    <div class="t-file__info">
                                        <div class="t-file__name">{{ itemFile.name }}</div>
                                        <div>{{ itemFile.type }}, {{ Math.ceil(itemFile.size/1000) }} KB </div>
                                    </div>
                                    <svg class="t-file__del" @click="DelFile(item, itemFile, indexFile )" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M21 12C21 11.4477 20.5523 11 20 11C19.4477 11 19 11.4477 19 12V13H15C14.4477 13 14 13.4477 14 14C14 14.5523 14.4477 15 15 15H20H25C25.5523 15 26 14.5523 26 14C26 13.4477 25.5523 13 25 13H21V12ZM14 16C13.7035 16 13.4223 16.1316 13.2323 16.3593C13.0423 16.5869 12.9631 16.8871 13.0161 17.1789L13.7434 21.1789L14.4707 25.1789L15.0161 28.1789C15.1026 28.6544 15.5167 29 16 29H24C24.4833 29 24.8974 28.6544 24.9839 28.1789L26.2566 21.1789L26.9839 17.1789C27.0369 16.8871 26.9578 16.5869 26.7678 16.3593C26.5778 16.1316 26.2965 16 26 16H14ZM15.5619 20L15.1982 18H24.8018L24.4382 20H15.5619ZM16.2891 24L15.9255 22H24.0745L23.7109 24H16.2891ZM16.8346 27L16.6528 26H23.3473L23.1654 27H16.8346Z" fill="#52A8F2"/>
                                    </svg>
                                </div>
                            </div>
                        </transition>
                    </template>

                    <v-select v-if="item.type === 'select'"
                            v-model="item.value"
                            :options="item.options"
                            :searchable="true"
                            :filterable="true"></v-select>
                </div>

            </transition-group>
        <button class="t-btn" :disabled="!personalInfo" :class="{_disabled: disabledBtn}"><span>{{ banner.btn }}</span></button>
        <button class="t-btn t-btn_white" @click="modalDialogClose()" type="reset"><span>{{ banner.cancell }}</span></button>
        
    </form>
</template>

<script>
    import {store} from '../../store'

    import {mapGetters} from 'vuex';
    import {mapActions} from 'vuex';

    export default {
        data(){
            return{
                disabledBtn: false,
                action: 'recblock/buy',
                form: [
                    {
                        type: 'select',
                        label: store.getters['staticText/banner'].type,
                        name: 'type',
                        value: '',
                        options: store.getters['handbook/bannerType'],
                        placeholder: store.getters['staticText/banner'].typePlaceholder,
                        error: false,
                        pattern: '',
                        visible: true
                    },
                    {
                        type: 'text',
                        label: store.getters['staticText/banner'].link,
                        name: 'link',
                        required: true,
                        value: '',
                        placeholder: store.getters['staticText/banner'].linkPlaceholder,
                        error: false,
                        pattern: '',
                        visible: true
                    },
                    {
                        type: 'file',
                        label: store.getters['staticText/banner'].file,
                        labelSub: store.getters['staticText/banner'].fileSub,
                        name: 'file',
                        required: true,
                        value: '',
                        placeholder: store.getters['staticText/banner'].filePlaceholder,
                        error: false,
                        pattern: '',
                        visible: false
                    },
                    {
                        type: 'textarea',
                        label: store.getters['staticText/banner'].comment,
                        name: 'comment',
                        value: '',
                        placeholder: store.getters['staticText/banner'].commentPlaceholder,
                        error: false,
                        pattern: '',
                        visible: true
                    },
                ],
                // personalInfo: false
            }
        },
        watch: {
            formItemType(){
                this.form.find(item => item.name == 'file').visible = this.formItemType == 2;
            }
        },
        computed: {
            ...mapGetters(['mobile']),
            ...mapGetters('staticText', ['banner']),
            ...mapGetters('handbook', ['bannerType']),
            formCurrent:{
                get(){
                    return this.form.filter(item => item.visible);
                },
                set(newValue){
                    // return this.form.filter(item => item.visible);
                    this.form = newValue
                },
            },
            formItemType(){
                return this.form.find(item => item.name == 'type').value.value;
            },
            personalInfo(){
                for (let index = 0; index < this.form.length; index++) {
                    if(this.form[index].visible && this.form[index].required && this.form[index].value == ''){
                        return false;
                    }
                }
                return true;
            }
        },
        methods: {
            ...mapActions('modal', ['modalDialogClose']),
            ...mapActions('msg', ['showMsg']),
            LoadFile(files, item){
                item.value = files;
            },
            DelFile(item, file, indexFile){
                if (item.value.length > 0){
                    let fileArray = Array.from(item.value);
                    fileArray.splice(indexFile, 1);
                    item.value = fileArray
                } else {
                    item.value = '';
                }
                // file
                // item.value = '';
            },
            Submit(){
                this.disabledBtn = true;

                if(this.personalInfo){
                    let fd = new FormData();
                    for(let i = 0; i < this.form.length; i++){
                        if (this.form[i].visible) {
                            if(this.form[i].type === 'select'){
                                fd.append(this.form[i].name, this.form[i].value.value)
                            } else if(this.form[i].type === 'file') {
                                for (var j = 0; j < this.form[i].value.length; j++) {
                                    let file = this.form[i].value[j];
                                    // if file type could be detected
                                    if (file !== null) {
                                        fd.append(this.form[i].name, file)
                                    } 
                                }
                            } else {
                                fd.append(this.form[i].name, this.form[i].value)
                            }
                        }
                    }

                    this.$http.post(this.action, fd)
                        .then(response => response.json())
                        .then(data => {
                            if(data.success){
                                this.disabledBtn = false;
                                this.modalDialogClose();
                                this.showMsg(this.banner.msgSuccess)
                                this.$router.push({name: 'dialog', query: {sel: data.sel} });
                            } else {
                                this.modalDialogClose();
                                this.showMsg(this.banner.msgError)
                            }
                        }, data => {

                            this.disabledBtn = true;
                            this.modalDialogClose();
                            this.showMsg(this.banner.msgError)
                            // this.showMsg('Упс, что-то пошло не так, попробуйте позже')
                        });
                } else {

                    this.disabledBtn = true;
                    this.modalDialogClose();
                    this.showMsg('В форме нет данных');
                }
            },
            Focus(i){
                this.form[i].error = false
            }
        }
    }
</script>

<style lang="sass">
.t-banner-add
    width: 560px
    margin: 0 auto
    background: #ffffff
    padding: 24px
    border-radius: 16px
    &__hint
        font-size: 14px
        color: $grey
        margin-top: 8px
    .t-input:after
        bottom: 25px
</style>


// WEBPACK FOOTER //
// src/vue_components/ModalDialog/BannerAdd.vue